import React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

// Shared Reports-style actions preserve MUI icons, disabled states, refs, and accessibility props.
const StyledButton = styled(Button)({
  borderRadius: 9,
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  fontSize: 14, fontWeight: 600, lineHeight: 1.75, letterSpacing: '.02857em',
  textTransform: 'none', minHeight: 36, padding: '6px 14px',
  '&.MuiButton-contained': {
    color: '#fff', backgroundColor: '#244ba8', border: '1px solid #3764c0',
    boxShadow: '0 4px 10px -4px rgba(35, 73, 159, .5)',
    '&:hover': { backgroundColor: '#244ba8', boxShadow: '0 5px 12px -4px rgba(35, 73, 159, .6)' },
  },
  '&.MuiButton-outlined': {
    color: 'var(--report-accent, #315fca)', borderColor: 'var(--report-line, #dde5ee)',
    '&:hover': { backgroundColor: 'var(--report-tint, #edf3ff)', borderColor: 'var(--report-accent, #315fca)' },
  },
  '&.MuiButton-text': {
    color: 'var(--report-accent, #315fca)',
    '&:hover': { backgroundColor: 'var(--report-tint, #edf3ff)' },
  },
  '&.Mui-focusVisible': { outline: '3px solid var(--report-accent, #315fca)', outlineOffset: 3 },
  '&.Mui-disabled': { opacity: .45, color: 'var(--report-muted, #586b82)', boxShadow: 'none' },
  '&.MuiButton-contained.Mui-disabled': { color: '#fff', backgroundColor: '#244ba8' },
});

// Contained is the default; outlined and text provide secondary and quiet actions.
const ActionButton = React.forwardRef(function ActionButton({ variant = 'contained', type = 'button', className = '', ...props }, ref) {
  return <StyledButton {...props} ref={ref} type={type} variant={variant} className={`admin-action-button ${className}`} />;
});

export default ActionButton;
